<template>
  <BaseTable :name='name' :getDataAction='getDataAction' :tableColumns='tableColumns' :isShowCloseBtn='isShowCloseBtn' @SizeChange='sizeChange' @StateChange='stateChange'></BaseTable>
</template>


<script>
import {
  GetIntelligenceCounterStockViewModels
} from '@/api'
import BaseTable from './../baseTable.vue'

export default ({
  components: {
    BaseTable
  },
  data () {
    return {
      getDataAction: GetIntelligenceCounterStockViewModels,
      tableColumns: [
        {
          no: 'rfid',
          name: 'RFID',
          width: 110,
          type: 'text'
        },
        // {
        //   no: 'deptName',
        //   name: '科室',
        //   width: 100,
        //   type: 'text',
        // },
        {
          no: 'warehouseName',
          name: '库房名称',
          width: 100,
          type: 'text',
        },
        {
          no: 'productName',
          name: '产品名称',
          width: 100,
          type: 'text',
        },
        {
          no: 'specName',
          name: '规格型号',
          width: 100,
          type: 'text',
        },
        {
          no: 'manufacturerName',
          name: '生产厂家',
          width: 100,
          type: 'text',
        },
        {
          no: 'stockQuantity',
          name: '数量',
          width: 50,
          type: 'text',
        },
        {
          no: 'manufactureDate',
          name: '生产日期',
          width: 110,
          type: 'date',
          dateFormatter: '{y}-{m}-{d}'
        },
        {
          no: 'validityDate',
          name: '有效期',
          width: 110,
          type: 'date',
          dateFormatter: '{y}-{m}-{d}'
        },

      ],
    };
  },
  props: {
    name: {
      type: String,
      default () {
        return ''
      }
    },
    isShowCloseBtn: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  //监听beforinfo值的变化
  watch: {
  },
  methods: {

    sizeChange (a, b, c, d) {
      this.$emit('SizeChange', a, b, c, d)
    },
    stateChange (a, b) {
      this.$emit('StateChange', a, b)
    },
  },
  mounted () {
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
  },
  beforeDestroy () {
  },
})
</script>
<style scoped lang="scss">
</style>
